import { Button, Heading, Text } from '../ui/index.js'
import { ApiError } from '../lib/api.js'

function messageFor(error: unknown): string {
  if (error instanceof ApiError) return error.message
  if (error instanceof Error) return error.message
  // Never stringify an unknown value into the UI - "[object Object]" tells nobody anything.
  return 'Something went wrong.'
}

export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  return (
    <div className="state-block" role="alert">
      <Heading type="h3">That did not load</Heading>
      <Text color="secondary">{messageFor(error)}</Text>
      {onRetry !== undefined ? (
        <Button kind="secondary" size="small" onClick={onRetry}>
          Try again
        </Button>
      ) : null}
    </div>
  )
}
